import React, { useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Sparkle } from '@phosphor-icons/react';

/**
 * SurpriseSparkButton — $1 Stripe checkout that lands +5 ✦ and +5 energy
 * on a random stranger, optionally with a 120-char anonymous note.
 * The point is an impulse-buy gesture: light a candle for someone you'll
 * never meet.
 */
const SurpriseSparkButton = () => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/shop/spark', {
        origin_url: window.location.href,
        note: note.trim() || undefined,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'could not light it');
      setBusy(false);
    }
  };

  return (
    <>
      <button
        data-testid="surprise-spark-btn"
        onClick={() => setOpen(true)}
        className="px-4 py-2 rounded-full bg-bx-volt/15 hover:bg-bx-volt/25 text-bx-volt text-xs font-bold uppercase tracking-widest flex items-center gap-1.5">
        <Sparkle size={14} weight="fill" /> Send a Surprise Spark · $1
      </button>

      {open && (
        <div className="fixed inset-0 z-[300] grid place-items-center bg-black/85 backdrop-blur px-4" onClick={() => setOpen(false)}>
          <div className="glass rounded-3xl p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <div className="text-[10px] uppercase tracking-widest text-bx-volt">surprise spark · $1</div>
            <div className="font-display text-2xl font-black mt-1">Light a candle for a stranger.</div>
            <p className="text-white/60 text-sm mt-2">
              A random someone will wake up to +5 ✦ Resonance, +5 energy, and your note (if you leave one). They will never know who you are.
            </p>
            <textarea
              data-testid="spark-note"
              value={note}
              maxLength={120}
              onChange={(e) => setNote(e.target.value)}
              rows={2}
              placeholder="optional · 120 chars"
              className="mt-4 w-full rounded-2xl glass-hi p-3 text-sm text-white placeholder-white/30 outline-none"
            />
            <div className="text-right text-[10px] text-white/60">{note.length}/120</div>
            <div className="mt-3 flex gap-2">
              <button
                onClick={() => setOpen(false)}
                className="flex-1 px-4 py-2 rounded-full glass-hi text-xs uppercase tracking-widest font-bold hover:bg-white/10">
                not yet
              </button>
              <button
                onClick={send}
                disabled={busy}
                data-testid="spark-confirm"
                className="flex-1 btn-volt px-4 py-2 rounded-full text-xs font-bold disabled:opacity-50">
                {busy ? 'opening…' : 'light it · $1'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SurpriseSparkButton;
